// dateAppliedReducer.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isDateChanged: false, // ✅ default = DO NOT LOAD
};

const DateAppliedReducer = createSlice({
    name: "DateAppliedReducer",
    initialState,
    reducers: {
        updateDataFlag: (state, action) => {
            state.isDateChanged = action.payload;
        }
    }
});

export const { updateDataFlag } = DateAppliedReducer.actions;
export default DateAppliedReducer.reducer;
